<template>
  <section :id="`questionnaire-${uuid}`" class="questionnaire">
    <div ref="questionnaireInner" class="questionnaire__inner" tabindex="-1">
      <slot name="header" />
      <bpb-form
        class="form--width-100 form--questionnaire"
        :before-submit-hook="submitHook"
      >
        <bpb-form-stepper
          :advance-step-callback="focusQuestionnaire"
          :start-at-index="formStepperStartIndex"
          :perform-initial-get-request="hasStoredSurveyParticipation"
        >
          <!-- <div class="a-visually-hidden" aria-live="polite">
            <a-label path="questionnaire.step"></a-label>
            <bpb-form-stepper-counter></bpb-form-stepper-counter>
          </div> -->
          <div>
            <slot />
          </div>
        </bpb-form-stepper>
      </bpb-form>
    </div>
  </section>
</template>

<script>
export default {
  provide() {
    const questionnaireContext = {};

    Object.defineProperty(questionnaireContext, 'advanceQuestioning', {
      enumerable: true,
      get: () => this.advanceQuestioning,
    });

    Object.defineProperty(questionnaireContext, 'registerQuestion', {
      enumerable: true,
      get: () => this.registerQuestion,
    });

    Object.defineProperty(questionnaireContext, 'questionAmount', {
      enumerable: true,
      get: () => this.questionAmount,
    });

    Object.defineProperty(questionnaireContext, 'questionIndex', {
      enumerable: true,
      get: () => this.questionIndex,
    });

    Object.defineProperty(questionnaireContext, 'uuid', {
      enumerable: true,
      get: () => this.uuid,
    });

    Object.defineProperty(
      questionnaireContext,
      'hasStoredSurveyParticipation',
      {
        enumerable: true,
        get: () => this.hasStoredSurveyParticipation,
      }
    );

    questionnaireContext.rememberSurveyParticipation =
      this.rememberSurveyParticipation;

    return {
      questionnaireContext,
    };
  },
  props: {
    beforeSubmitHook: {
      type: [String, Function],
      default() {
        return () => true;
      },
    },
    surveyId: {
      type: String,
      default: '',
    },
    ifHasSurveyParticipationStartAtIndex: {
      type: Number,
      default: undefined,
    },
    startAtIndex: {
      type: Number,
      default: undefined,
    },
  },
  data: function () {
    return {
      questionAmount: 0,
      questionIndex: 0,
      uuid: this.$uuid.v1(),
    };
  },
  computed: {
    submitHook() {
      if (!this.beforeSubmitHook) return false;
      return this[this.beforeSubmitHook];
    },
    items() {
      return this.$store.getters['survey/items'];
    },
    hasStoredSurveyParticipation() {
      return this.items.includes(this.surveyId);
    },
    formStepperStartIndex() {
      if (
        this.hasStoredSurveyParticipation &&
        this.ifHasSurveyParticipationStartAtIndex >= 0
      )
        return this.ifHasSurveyParticipationStartAtIndex;
      if (this.startAtIndex >= 0) return this.startAtIndex;
      return -1;
    },
  },
  methods: {
    registerQuestion() {
      this.questionAmount++;
    },
    advanceQuestioning(index) {
      this.questionIndex = index;
    },
    focusQuestionnaire() {
      this.$refs.questionnaireInner.focus();
    },
    forgetSurveyParticipation() {
      this.$store.dispatch('survey/remove', {
        item: this.surveyId,
      });
    },
    rememberSurveyParticipation() {
      if (this.hasStoredSurveyParticipation || !this.surveyId) return;
      this.$store.dispatch('survey/add', {
        item: this.surveyId,
      });
    },
  },
};
</script>
